module.exports = __webpack_public_path__ + "media/images/summit-3-ea1f3b23187d7fdb7c2ce332330ca31e.jpg";